import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  selector: 'app-auth-callback',
  template: '<div class="loading">Processing authentication...</div>',
  styles: [`
    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-size: 18px;
    }
  `],
  standalone: true
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.handleCallback();
  }

  private async handleCallback(): Promise<void> {
    try {
      console.log('[AuthCallback] Starting callback processing');
      console.log('[AuthCallback] Current URL:', window.location.href);
      
      await this.oktaAuth.handleLoginRedirect();
      
      console.log('[AuthCallback] handleLoginRedirect completed');
      
      const tokenManager = this.oktaAuth.tokenManager;
      const accessToken = await tokenManager.get('accessToken');
      const idToken = await tokenManager.get('idToken');
      
      if (!accessToken || !idToken) {
        console.error('[AuthCallback] Tokens missing after callback');
        this.router.navigate(['/file-explorer']); 
        return;
      }
      
      const originalUri = this.oktaAuth.getOriginalUri();
      
      const targetPath = originalUri ? 
        originalUri.replace(window.location.origin, '') : 
        '/file-explorer';
      
      await this.router.navigateByUrl(targetPath);
      
    } catch (error) {
      console.error('[AuthCallback] Error during callback:', error);
      this.router.navigate(['/file-explorer']);
    }
  }
}